import styled from 'styled-components'

const ProductOptionsContainerUi = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
`

export default ProductOptionsContainerUi
